import { Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { OpportunitySnapshotsService } from '../../services/opportunity-snapshots.service';
import { SurplusLinesExistingCoverage, SurplusLinesPlanDesignsRequest } from '../../models/surplus-lines-plan-design.model';

@Component({
  selector: 'app-infectious-disease',
  standalone: false,
  templateUrl: './infectious-disease.component.html',
  styleUrl: '../../../assets/css/HighLimitsDialogs.css'
})
export class InfectiousDiseaseComponent {
  readonly dialogRef = inject(MatDialogRef<InfectiousDiseaseComponent>);
  IDRDurationOptions: string[] = [];
  IDRDuration: string = '';
  cost: string = '';
  monthlyBenefit: string = '';
  eliminationPeriod: string = '';
  planDesignRequest: SurplusLinesPlanDesignsRequest = new SurplusLinesPlanDesignsRequest();
  additionalPlanDesignRequest: SurplusLinesPlanDesignsRequest = new SurplusLinesPlanDesignsRequest();

  constructor(private _oss: OpportunitySnapshotsService) {
  }

  ngOnInit() {
    this.IDRDurationOptions = this.getInfectiousDiseaseOptions();
    if (this.IDRDuration == '') {
      this.IDRDuration = this._oss.currentQuoteOptions?.IDRDurationDefault as string;
    }
    this.updateCost();
  }

  getInfectiousDiseaseOptions() {
    if (this._oss.currentQuoteOptions == null) {
      return [];
    }
    return this._oss.currentQuoteOptions.IDRDurationOptions.replaceAll('; ', ';').split(';');
  }

  updateCost() {
    var existingCoverages: SurplusLinesExistingCoverage[] = [];

    this._oss.currentOpportunitySnapshot.OtherInsurance.forEach(element => {
      var existing = new SurplusLinesExistingCoverage();
      existing.Amount = element.MonthlyAmount;
      existing.Type = element.Type;
      existing.Payee = element.Paid;
      existingCoverages.push(existing);
    });

    this.additionalPlanDesignRequest.OpportunityId = this._oss.currentCompassOpportunity?.CompassId as number;
    this.additionalPlanDesignRequest.EarnedIncome = this._oss.currentApplicant.AnnualIncome;
    this.additionalPlanDesignRequest.ExistingCoverages = existingCoverages;
    this.additionalPlanDesignRequest.InsuredId = this._oss.currentCompassOpportunity?.InsuredId as number;
    this.additionalPlanDesignRequest.TTDMonthlyBenefit = this.monthlyBenefit;
    this.additionalPlanDesignRequest.EP = this.eliminationPeriod;
    this.additionalPlanDesignRequest.IDRDuration = this.IDRDuration;
    this.additionalPlanDesignRequest.BenefitDuration = this._oss.currentQuoteOptions?.DurationDefault as string;

    this._oss.getQuote(this._oss.currentOpportunitySnapshot.OpportunityId, this.planDesignRequest).subscribe(originalQuote => {
      this._oss.getQuote(this._oss.currentOpportunitySnapshot.OpportunityId, this.additionalPlanDesignRequest).subscribe(additionalQuote => {
        this.cost = String(additionalQuote[0].YearOneCost - originalQuote[0].YearOneCost);
      });
    });
  }

  inclusion() {
    if (this._oss.currentQuoteOptions?.IDRInclusion == 'Y') {
      return true;
    }
    return false;
  }

  yes() {
    this.dialogRef.close({ IDRDuration: this.IDRDuration, cost: this.cost });
  }

  no() {
    this.dialogRef.close(false);
  }
}
